/**
 * PipelineSteps Component
 * 지식 파이프라인 하위 메뉴 공통 - 단계 카드(일러스트 + 제목 + 설명)를 화살표로 이어 가로 배치
 *
 *   <PipelineSteps
 *     steps={[
 *       { illust: step01Svg, title: '수집', desc: '파일 · 웹 · DB' },
 *       { illust: step02Svg, title: '추출 · 정제', desc: 'OCR, 표 구조화, 노이즈 제거' },
 *     ]}
 *   />
 *
 * - illust: <img> src (import 한 svg 경로). 역할별(admin/user) 이미지는 호출하는 쪽에서 선택
 * - 스타일: styles/kbPipeline.css "PipelineSteps" 섹션
 */

import { Fragment, ReactNode } from 'react';

export interface PipelineStep {
  illust: string;
  title: ReactNode;
  desc?: ReactNode;
}

interface PipelineStepsProps {
  steps: PipelineStep[];
  className?: string;
}

export function PipelineSteps({ steps, className = '' }: PipelineStepsProps) {
  return (
    <div className={`pipeline-steps ${className}`.trim()}>
      {steps.map((step, idx) => (
        <Fragment key={idx}>
          {idx > 0 && <div className="pipeline-step-arrow" aria-hidden="true">→</div>}
          <div className="pipeline-step-card">
            <img className="pipeline-step-illust" src={step.illust} alt="" />
            <div className='pipeline-step-content'>
              <div className="pipeline-step-title">{step.title}</div>
              {step.desc && <div className="pipeline-step-desc">{step.desc}</div>}
            </div>
          </div>
        </Fragment>
      ))}
    </div>
  );
}

export default PipelineSteps;
